import { render, staticRenderFns } from "./SwitchForm.vue?vue&type=template&id=2ff0bea2&scoped=true"
import script from "./SwitchForm.vue?vue&type=script&lang=js"
export * from "./SwitchForm.vue?vue&type=script&lang=js"
import style0 from "./SwitchForm.vue?vue&type=style&index=0&id=2ff0bea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0bea2",
  null
  
)

export default component.exports